import { createApp } from 'vue';
import ContactForm from '@/components/ContactForm.vue';

createApp(ContactForm).mount('#contact-form');
